import type { ModelViewButtonProps } from "./model-view-button.type";
import type { ModelItem } from "@/modules/model";
import type { ButtonProps } from "antd";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useModelNavigate } from "@/modules/model-navigate";

const ModelViewButton = <Item extends ModelItem>({
  modelKey,
  item,
  onClick,
  ...buttonProps
}: ModelViewButtonProps<Item>) => {
  const { t } = useTranslation();
  const { navigateToModel } = useModelNavigate();

  const onViewClick: ButtonProps["onClick"] = (e) => {
    navigateToModel(modelKey, { id: item.id });
    onClick?.(e);
  };

  return (
    <Button onClick={onViewClick} {...buttonProps}>
      {t("global:view")}
    </Button>
  );
};

export default ModelViewButton;
